import React, { useState } from "react";
import { Modal, Button } from 'antd'
import { PDFViewer } from "./PDFviewer";
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom';
import { getFilePath, getFilePathForView } from "../../library/constants";

const ViewAndDownload = ({ project_id, item_id, name }) => {
    const [fileModal, showFileModal] = useState(false)
    return (
        <div><div className={`actions--compact`}>
            <Button onClick={() => { showFileModal(true) }} className="button" ><img src="/icons/lens-plus.svg" />View</Button>
            <Link reloadDocument to={getFilePath(name,project_id, item_id)} className="button">
                <Button icon={<img src="/icons/download.svg" />}>Download</Button>
            </Link>
        </div>
            <Modal  onCancel={() => { showFileModal(false) }} footer={null} open={fileModal}>
                <PDFViewer path={getFilePathForView(name,project_id, item_id)} />
            </Modal></div>
    )
}

ViewAndDownload.propTypes = {
    project_id: PropTypes.number,
    item_id: PropTypes.number,
    name: PropTypes.string
};
export default ViewAndDownload